<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :data-color="backgroundColor" :class="pageClass">
        <div class="content">
          <div class="container">
            <slot></slot>
          </div>
        </div>

        <div class="full-page-background"
             :style="`background-image: url('${backgroundImage}')`"></div>
      </div>
    </div>
  </div>
</template>
<script>
import backgroundImage from "../../assets/img/full-screen-image-1.jpg";

export default {
  computed: {
    backgroundImage() {
      return backgroundImage;
    }
  },
  props: {
    pageClass: {
      type: String,
      default: "login-page"
    },
    backgroundColor: {
      type: String,
      default: "black"
    }
  }
};
</script>
<style scoped>
</style>
